export const columnsReportUser = [
   {
      headerName: 'Usuario',
      field: 'user.fullName',
      filter: true,
      sortable: true,
      resizable: true,
   },
   {
      headerName: 'Creditos usados',
      field: 'amount',
      filter: true,
      sortable: true,
      resizable: true,
   },
   {
      headerName: 'Tipo',
      field: 'type',
      filter: true,
      sortable: true,
      resizable: true,
   },
   {
      headerName: 'Club',
      field: 'tower.name',
      filter: true,
      sortable: true,
      resizable: true,
   },

   {
      headerName: 'Fecha',
      field: 'createdAt',
      cellRenderer: 'agFullDateCellRenderer',
      filter: true,
      sortable: true,
      resizable: true,
   },
];
